import { render, staticRenderFns } from "./Parceiros.vue?vue&type=template&id=64fbc1b0&scoped=true&"
import script from "./Parceiros.vue?vue&type=script&lang=js&"
export * from "./Parceiros.vue?vue&type=script&lang=js&"
import style0 from "./Parceiros.vue?vue&type=style&index=0&id=64fbc1b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fbc1b0",
  null
  
)

export default component.exports